import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Room8 = (props) => {
  let [state, setState] = React.useState({
    resutlTime: 0,
  })

  const addZeroBefore = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  function convertMsToHM(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;
    //return `${hours}:${minutes}:${seconds}`;
    return `${addZeroBefore(hours)}:${addZeroBefore(minutes)}:${addZeroBefore(seconds)}`;
  }

  const th = 1000* 60 * 60 * 1.5;

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  React.useEffect(() => {
    let tl = th - props.endtime;
    setState(prevState => ({
      ...prevState,
      resutlTime: tl
    }));

  }, [props.endtime])


    return(
      <div className="landing ">
        {stars}

        <div className='logoMuseo'>
          <CommonSvgContent stringToRet="logoMuseo" />
        </div>

        <div className='collaborazione'>
          <p>In collaborazione con</p>
          <h3>INAF-Osservatorio<br />
          Astronomico<br />
          di Brera </h3>
        </div>

        <div className='logo'>
          <ContentLanding stringToRet="logo" />
        </div>
        <div className="content contratulation">
          <h3>TEMPO: <span>{convertMsToHM(state.resutlTime)}</span> PENALITÀ: <span>{props.penality}</span></h3>

          <p>Ti ringraziamo per aver giocato con noi e ci auguriamo di avervi fatto nascere una scintilla
          di curiosità per l’<strong>affascinante storia di Giovanni Virginio Schiaparelli</strong>.<br />
          Tutti i documenti e le informazioni che hai consultato durante il gioco sono in parte
          scientificamente esatti e in parte rielaborati a scopi di fiction.</p>
          <p>Nel corso dei suoi studi Schiaparelli davvero si lasciò andare a fantasie pubblicate negli
          articoli <strong>«La vita sul pianeta Marte»</strong> rivolti ad un pubblico generico di non scienziati ipotizzando
          una vita intelligente su Marte. Di volare sulle ali della fantasia lui ne fu sempre consapevole
          (era uno scienziato molto serio e scrupoloso) tanto da usare la metafora del <strong>«salire e scendere
          dall’Ippogrifo»</strong>. A partire dagli inizi del secolo scorso, con l’introduzione di strumenti più potenti,
          l’evidenza osservativa a favore dell’esistenza sul pianeta di esseri intelligenti, già tenue
          negli anni precedenti, scomparve del tutto. A Schiaparelli sono sopravvissute le <strong>splendide mappe
          del pianeta</strong>, <strong>la nomenclatura dei vari luoghi individuati</strong>, e naturalmente la <strong>fama di essere uno
          dei più stimati e famosi astronomi della sua epoca</strong>.</p>
          <p className="bigger">Se vuoi scoprire la vera storia di Giovanni Virginio Schiaparelli e di come sia nato il mito
          dei «marziani», <strong>puoi venire a trovarci al Museo della Scienza e all’Osservatorio Astronomico di Brera</strong>.</p>
        </div>



        <div className="mars">
          <ContentLanding stringToRet="mars" />
        </div>

        <div className="buttonsBlocks">
          <Link className="btn btn-success" to="/classifica">CLASSIFICA</Link>
          {/*<a className="btn btn-success" href="https://vivaticket.com">condividi</a>*/}
        </div>

        <p className="scopri">SCOPRI DI PIÙ</p>
        <div className="buttonsBlocks">

        <a className="btn btn-danger" target="_blank" href="https://www.museoscienza.org/">MUSEOSCIENZA.ORG</a>
        <a className="btn btn-danger" target="_blank" href="http://www.brera.inaf.it/">BRERA.INAF.IT</a>
        </div>



      </div>
    )
}
